import { Landmark } from "lucide-react";
import AmountInput from "../AmountInput";
import AssetDocGroup from "./AssetDocGroup";
import DeedMortgages from "./DeedMortgages";
import PolicyDates from "./PolicyDates";
import { L, cls, emptyDeed } from "./assetShared";

// sıra: adres, ili, ilçesi, mah., ada, parsel, niteliği, blok, kat, no, sahibi, piyasa değeri; ipotek bilgileri (ekspertiz / banka / derece) Limit Risk'ten otomatik
const TEXT_FIELDS = [
  ["province", "İli"], ["district", "İlçesi"], ["neighborhood", "Mah."], ["block_no", "Ada"], ["parcel_no", "Parsel"],
  ["nature", "Niteliği"], ["building_block", "Blok"], ["floor", "Kat"], ["door_no", "No"], ["owner", "Sahibi"],
];
export const DEED_DOCS = { tapu: "Tapu Görseli", dask: "DASK Görseli", konut: "Konut Sigortası Görseli" };

// tapu bilgileri (arazi/arsa + bina): alanlar + (düzenlemede) tapu / dask / konut sigortası görselleri
export default function DeedSection({ editing, form, setForm, isAdmin }) {
  const deed = { ...emptyDeed, ...(form.deed || {}) };
  const set = (k) => (e) => setForm({ ...form, deed: { ...deed, [k]: e.target.value } });
  const setAmt = (k) => (v) => setForm({ ...form, deed: { ...deed, [k]: v } });
  const patch = (p) => setForm({ ...form, deed: { ...deed, ...p } });
  const isEdit = editing !== "new";
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50/40 p-4" data-testid="deed-section">
      <div className="text-[11px] font-bold uppercase tracking-wide text-amber-900 inline-flex items-center gap-1.5 mb-3"><Landmark className="w-4 h-4" /> Tapu Bilgileri</div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <div className="col-span-2 md:col-span-5"><L label="Adres"><input data-testid="deed-field-address" value={deed.address} onChange={set("address")} className={cls} /></L></div>
        {TEXT_FIELDS.map(([k, label]) => <L key={k} label={label}><input data-testid={`deed-field-${k}`} value={deed[k]} onChange={set(k)} className={cls} /></L>)}
        <L label="Piyasa Değeri"><AmountInput testid="deed-field-market_value" value={deed.market_value || ""} onChange={setAmt("market_value")} className={cls} placeholder="örn. 5.000.000,00" /></L>
        <PolicyDates prefix="deed" k="dask" label="DASK" data={deed} onChange={patch} />
        <PolicyDates prefix="deed" k="konut" label="Konut Sigortası" data={deed} onChange={patch} />
      </div>
      <DeedMortgages assetId={isEdit ? editing : null} legacy={deed} />
      <AssetDocGroup assetId={isEdit ? editing : null} types={DEED_DOCS} group="tapu_grubu" prefix="deed" isAdmin={isAdmin} ends={{ dask: deed.dask_end, konut: deed.konut_end }}
        pending={form.pending_docs || {}} onPending={(t, f) => setForm({ ...form, pending_docs: { ...(form.pending_docs || {}), [t]: f } })} />
      {!isEdit && <div className="text-[11px] text-slate-600 mt-2" data-testid="deed-docs-after-save">Tapu / DASK / Konut Sigortası PDF veya görselini şimdi seçin; Kaydet ile demirbaşla birlikte yüklenir (her türden son 2 görsel saklanır).</div>}
    </div>
  );
}
